const PURCHASE_TYPES = {
  SHIPPING: 1,
  PICKUP: 2,
};

class PaymentType {
  constructor(params) {
    this.description = params.description;
    this.detail = params.detail;
    this.id = params.id;
    this.typeReference = params.typeReference;
    this.references = params.references;
  }
}

export { PaymentType, PURCHASE_TYPES };



// WEBPACK FOOTER //
// ./src/models/PaymentType.js